














import Vue from "vue";
import Component from "vue-class-component";
import WebsiteHeader from "@/components/WebsiteHeader/index.vue";
import WebsiteFooter from "@/components/WebsiteFooter/index.vue";
@Component({ components: { WebsiteHeader, WebsiteFooter } })
export default class Layout extends Vue {
  private contentHeight = "0";
  mounted() {
    this.contentHeight = this.getContentHeight();
  }

  getContentHeight() {
    const windowHeight = window.innerHeight;
    const dom1 = window.document.querySelector(".website-header-wrap");
    const dom2 = window.document.querySelector(".website-footer-wrap");
    if (dom1 && dom2) {
      const height1 = parseFloat(
        window.getComputedStyle(dom1).height.replace("px", "")
      );
      const height2 = parseFloat(
        window.getComputedStyle(dom2).height.replace("px", "")
      );
      return `${windowHeight - height1 - height2}px`;
    }
    return "0";
  }
}
